(function () {
  var isLoading = false;
  var nextPageUrl = null;
  var grid = null;
  var loadMoreBtn = null;
  var scrollBound = false;
  var throttleTimer = null;

  function init() {
    if (loadMoreBtn) {
      loadMoreBtn.remove();
      loadMoreBtn = null;
    }
    isLoading = false;

    grid = document.getElementById('product-grid');
    if (!grid) return;

    /* Find next page URL from pagination */
    nextPageUrl = getNextPageUrl();
    if (!nextPageUrl) return;

    /* Hide traditional pagination */
    var paginationWrappers = document.querySelectorAll('.pagination-wrapper');
    paginationWrappers.forEach(function (p) {
      p.style.display = 'none';
    });

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion) {
      loadMoreBtn = document.createElement('button');
      loadMoreBtn.className = 'bigdex-load-more';
      loadMoreBtn.textContent = 'Load More';
      grid.parentNode.appendChild(loadMoreBtn);
      loadMoreBtn.addEventListener('click', function () {
        loadNextPage();
      });
      return;
    }

    /* Bind scroll listener once */
    if (!scrollBound) {
      scrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    /* Check immediately in case grid bottom is already near viewport */
    setTimeout(checkAndLoad, 500);
  }

  function getNextPageUrl() {
    /* Dawn names the "next" arrow .pagination__item--prev */
    var nextLink = document.querySelector(
      '.pagination__item--prev[aria-label]'
    );
    if (nextLink && nextLink.href) return nextLink.href;
    return null;
  }

  function onScroll() {
    if (throttleTimer) return;
    throttleTimer = setTimeout(function () {
      throttleTimer = null;
      checkAndLoad();
    }, 100);
  }

  function checkAndLoad() {
    if (!grid || !nextPageUrl || isLoading) return;

    var gridRect = grid.getBoundingClientRect();
    var triggerPoint = window.innerHeight + 600;

    /* Load when grid bottom is within 600px of viewport bottom */
    if (gridRect.bottom < triggerPoint) {
      loadNextPage();
    }
  }

  function createSkeletons(count) {
    var skeletons = [];
    for (var i = 0; i < count; i++) {
      var li = document.createElement('li');
      li.className = 'grid__item bigdex-skeleton';
      li.innerHTML =
        '<div class="bigdex-skeleton__card">' +
        '<div class="bigdex-skeleton__image"></div>' +
        '<div class="bigdex-skeleton__text"></div>' +
        '<div class="bigdex-skeleton__price"></div>' +
        '</div>';
      skeletons.push(li);
      grid.appendChild(li);
    }
    return skeletons;
  }

  function removeSkeletons(skeletons) {
    skeletons.forEach(function (el) {
      el.remove();
    });
  }

  function loadNextPage() {
    if (!nextPageUrl || isLoading) return;

    isLoading = true;

    if (loadMoreBtn) {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;
    }

    var skeletons = createSkeletons(4);
    var fetchUrl = nextPageUrl;

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newProducts = doc.querySelectorAll('#product-grid > li');

        removeSkeletons(skeletons);

        var currentCount = grid.querySelectorAll(
          ':scope > li:not(.bigdex-skeleton)'
        ).length;

        newProducts.forEach(function (item, index) {
          item.style.setProperty(
            '--animation-order',
            currentCount + index + 1
          );
          grid.appendChild(item);
        });

        /* Check fetched page for its next page link */
        var fetchedNextLink = doc.querySelector(
          '.pagination__item--prev[aria-label]'
        );
        if (fetchedNextLink && fetchedNextLink.getAttribute('href')) {
          var href = fetchedNextLink.getAttribute('href');
          if (href.indexOf('http') !== 0) {
            href = window.location.origin + href;
          }
          nextPageUrl = href;
        } else {
          nextPageUrl = null;
        }

        history.replaceState(null, '', fetchUrl);

        isLoading = false;

        if (loadMoreBtn) {
          if (nextPageUrl) {
            loadMoreBtn.textContent = 'Load More';
            loadMoreBtn.disabled = false;
          } else {
            loadMoreBtn.remove();
            loadMoreBtn = null;
          }
        }

        /* Check again immediately — if still near bottom, load next page too */
        if (nextPageUrl) {
          setTimeout(checkAndLoad, 200);
        }
      })
      .catch(function (err) {
        console.error('[BigDex Infinite Scroll]', err);
        removeSkeletons(skeletons);
        isLoading = false;
        if (loadMoreBtn) {
          loadMoreBtn.textContent = 'Load More';
          loadMoreBtn.disabled = false;
        }
      });
  }

  /* Initialize after DOM + deferred scripts are ready */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    init();

    /* Re-initialize when Dawn's facets.js swaps the grid (filter/sort) */
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var reinitTimer = null;
      new MutationObserver(function () {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(init, 300);
      }).observe(container, { childList: true });
    }
  });
})();
